import { DemographyClassificationMapper } from '../mapper/DemographyClassificationMapper';

export const demographyClassificationMapper = new DemographyClassificationMapper();
